import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CkEditorBlog from "../Forms/CkEditor/CkEditorBlog";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import CustomClassicEditor from "../CustomClassicEditor";

import NoImage from "../../../images/no-image.jpg";
import Select from "react-select";
import { Button, Collapse } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import {
  addCountry,
  getCountryById,
  updateCountry,
} from "../../../services/CountryService";
import Swal from "sweetalert2";
import {
  createAboutPage,
  getAboutPage,
} from "../../../services/AboutPageService";
import {
  createStudyPage,
  getStudyPage,
} from "../../../services/StudyPageService";
import { createJobPage, getJobPage } from "../../../services/JobPageService";
import {
  createBankAccountPage,
  getBankAccountPage,
} from "../../../services/BankAccountPageService";
import {
  createSupportPage,
  getSupportPage,
} from "../../../services/SupportPageService";
import {
  createAccommodationPage,
  getAccommodationPage,
} from "../../../services/AccommodationPageService";
import {
  createForexExchangePage,
  getForexExchangePage,
} from "../../../services/ForexExchangePageService";
import {
  createVisaAppointmentPage,
  getVisaAppointmentPage,
} from "../../../services/VisaAppoinmentPageService";
import {
  createVisaDocumentPage,
  getVisaDocumentPage,
} from "../../../services/VisaDocumentPageService";
import { createCourseFinderPage, getCourseFinderPage } from "../../../services/CourseFinderPageService";

const initialState = true;
const reducer = (state, action) => {
  switch (action.type) {
    case "collpase0":
      return { ...state, collpase0: !state.collpase0 };
    case "collpase1":
      return { ...state, collpase1: !state.collpase1 };
    case "collpase2":
      return { ...state, collpase2: !state.collpase2 };
    case "collpase3":
      return { ...state, collpase3: !state.collpase3 };
    case "collpase4":
      return { ...state, collpase4: !state.collpase4 };
    case "collpase5":
      return { ...state, collpase5: !state.collpase5 };
    case "collpase6":
      return { ...state, collpase6: !state.collpase6 };
    case "collpase7":
      return { ...state, collpase7: !state.collpase7 };
    case "collpase8":
      return { ...state, collpase8: !state.collpase8 };
    case "collpase9":
      return { ...state, collpase9: !state.collpase9 };
    case "collpase10":
      return { ...state, collpase10: !state.collpase10 };
    case "collpase11":
      return { ...state, collpase11: !state.collpase11 };
    case "collpase12":
      return { ...state, collpase12: !state.collpase12 };
    case "collpase13":
      return { ...state, collpase13: !state.collpase13 };
    case "section0":
      return { ...state, section0: !state.section0 };
    case "section1":
      return { ...state, section1: !state.section1 };
    case "section2":
      return { ...state, section2: !state.section2 };
    case "section3":
      return { ...state, section3: !state.section3 };
    case "section4":
      return { ...state, section4: !state.section4 };
    case "section5":
      return { ...state, section5: !state.section5 };
    case "section6":
      return { ...state, section6: !state.section6 };
    case "section7":
      return { ...state, section7: !state.section7 };
    case "section8":
      return { ...state, section8: !state.section8 };
    case "section9":
      return { ...state, section9: !state.section9 };
    default:
      return state;
  }
};

const AddCountry = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [addedCountryId, setAddedCountryId] = useState(null);
  const [countryName, setCountryName] = useState("");
  const [countryShowOnHome, setCountryShowOnHome] = useState(false);
  const [coutryAdd, setcoutryAdd] = useState(false);
  const [keyValues1, setKeyValues1] = useState([{ key: "", value: "", id: new Date().getTime() }]);
  const [keyValues2, setKeyValues2] = useState([{ key: "", value: "", id: new Date().getTime() }]);
  const [whyStudyInSection0Title, setWhyStudyInSection0Title] = useState("");
  const [aboutSection0Title, setAboutSection0Title] = useState("");
  const [aboutTitle, setAboutTitle] = useState("");
  const [aboutDesc, setAboutDesc] = useState("");
  const [aboutShortDesc, setAboutShortDesc] = useState("");
  const [aboutButtonDesc, setAboutButtonDesc] = useState("");
  const [studyTitle, setStudyTitle] = useState("");
  const [studyDesc, setStudyDesc] = useState("");
  const [studyShortDesc, setStudyShortDesc] = useState("");
  const [studyButtonDesc, setStudyButtonDesc] = useState("");

  const [courseFinderTitle, setCourseFinderTitle] = useState("");
  const [courseFinderDesc, setCourseFinderDesc] = useState("");
  const [courseFinderShortDesc, setCourseFinderShortDesc] = useState("");

  const [advantagesTitle, setAdvantagesTitle] = useState("");
  const [universitySectionTitle, setUniversitySectionTitle] = useState("");
  const [universitySectionTitleDesc, setUniversitySectionTitleDesc] = useState("");
  const [universitySectionTitleShortDesc, setUniversitySectionTitleShortDesc] = useState("");
  const [universitySectionDocuments, setUniversitySectionDocuments] = useState("");
  const [aboutSection1Title, setAboutSection1Title] = useState("");
  const [keyValues3, setKeyValues3] = useState([{ key: "", value: "", url: "", id: new Date().getTime() }]);
  const [keyValues6, setKeyValues6] = useState([{ key: "", value: "", id: new Date().getTime() }]);
  const [keyValues7, setKeyValues7] = useState([{ key: "", value: "", id: new Date().getTime() }]);
  const [keyValues8, setKeyValues8] = useState([{ key: "", value: "", id: new Date().getTime() }]);
  const [partTimeTitle, setPartTimeTitle] = useState("");
  const [partTimeDesc, setPartTimeDesc] = useState("");
  const [partTimeShortDesc, setPartTimeShortDesc] = useState("");
  const [financeTitle, setFinanceTitle] = useState("");
  const [financeDesc, setFinanceDesc] = useState("");
  const [financeSupportYoutubeTitle, setFianceSupportYoutubeTitle] = useState("");
  const [financeSupportYoutubeDesc, setFianceSupportYoutubeDesc] = useState("");
  const [financeSupportYoutubeLink, setFianceSupportYoutubeLink] = useState("");
  const [blockOpenAccountTitle, setBlockOpenAccountTitle] = useState("");
  const [blockOpenAccountDesc, setBlockOpenAccountDesc] = useState("");

  const [videos, setVideos] = useState([]);           // new uploaded files
  const [existingVideos, setExistingVideos] = useState([]); // from API (URLs)

  const [bankAboutTitle, setBankAboutTitle] = useState("");
  const [bankAboutDesc, setBankAboutDesc] = useState("");

  const [keyValues4, setKeyValues4] = useState([{ key: "" }]);
  const [accomationTitle, setAccomationTitle] = useState("");
  const [accomationDesc, setAccomationDesc] = useState("");
  const [accomationYoutubeTitle, setAccomationYoutubeTitle] = useState("");
  const [accomationYoutubeDesc, setAccomationYoutubeDesc] = useState("");
  const [accomationYoutubeLink, setAccomationYoutubeLink] = useState("");
  const [accomationAboutDesc, setAccomationAboutDesc] = useState("");
  const [accomationDocuments, setAccomationDocuments] = useState("");
  const [accomationDetails, setAccomationDetails] = useState([{ title: "", desc: "", image: "", badge: "", url: "", id: new Date().getTime() }]);
  const [accomationDetailsDesc, setAccomationDetailsDesc] = useState("");

  const [forexTitle, setForexTitle] = useState("");
  const [forexDesc, setForexDesc] = useState("");
  const [keyValues5, setKeyValues5] = useState([{ key: "", value: "" }]);
  const [forexYoutubeTitle, setForexYoutubeTitle] = useState("");
  const [forexYoutubeDesc, setForexYoutubeDesc] = useState("");
  const [forexYoutubeLink, setForexYoutubeLink] = useState("");

  const [forexAboutTitle, setForexAboutTitle] = useState("");
  const [forexAboutDesc, setForexAboutDesc] = useState("");
  const [forexAboutShortDesc, setForexAboutShortDesc] = useState("");

  const [visaAppoinmentTitle, setVisaAppoinmentTitle] = useState("");
  const [visaAppoinmentDesc, setVisaAppoinmentDesc] = useState("");
  const [visaAppoinmentYoutubeTitle, setVisaAppoinmentYoutubeTitle] = useState("");
  const [visaAppoinmentYoutubeDesc, setVisaAppoinmentYoutubeDesc] = useState("");
  const [visaAppoinmentYoutubeLink, setVisaAppoinmentYoutubeLink] = useState("");

  const [visaAppointmentSectionTitle, setVisaAppointmentSectionTitle] = useState("");
  const [visaAppointmentSectionDesc, setVisaAppointmentSectionDesc] = useState("");
  const [visaAppointmentDocTitle, setVisaAppointmentDocTitle] = useState("");
  const [visaAppointmentDocDesc, setVisaAppointmentDocDesc] = useState("");
  const [visaAppointmentApplicationTitle, setVisaAppointmentApplicationTitle] = useState("");
  const [visaAppointmentApplicationDesc, setVisaAppointmentApplicationDesc] = useState("");

  const [visaDocumentTitle, setVisaDocumentTitle] = useState("");
  const [visaDocumentDesc, setVisaDocumentDesc] = useState("");
  const [visaDocumentYoutubeTitle, setVisaDocumentYoutubeTitle] = useState("");
  const [visaDocumentYoutubeDesc, setVisaDocumentYoutubeDesc] = useState("");
  const [visaDocumentYoutubeLink, setVisaDocumentYoutubeLink] = useState("");

  const [visaDocumentSectionTitle, setVisaDocumentSectionTitle] = useState("");
  const [visaDocumentSectionDesc, setVisaDocumentSectionDesc] = useState("");
  const [visaDocumentDoDontTitle, setVisaDocumentDoDontTitle] = useState("");
  const [visaDocumentDoDontDesc, setVisaDocumentDoDontDesc] = useState("");
  const [visaDocumentAfterTitle, setVisaDocumentAfterTitle] = useState("");
  const [visaDocumentAfterDesc, setVisaDocumentAfterDesc] = useState("");

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const hasFetched = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  const cleanEditorContent = (html = "") => {
    if (!html) return "";

    let cleaned = html.trim();

    // loop because last may be [empty_line] + <p>&nbsp;</p> + [empty_line]
    let changed = true;

    while (changed) {
      changed = false;

      // remove only one trailing empty paragraph block
      const removedParagraph = cleaned.replace(
        /<p>(?:&nbsp;|\s|<br\s*\/?>)*<\/p>\s*$/i,
        ""
      );

      if (removedParagraph !== cleaned) {
        cleaned = removedParagraph.trim();
        changed = true;
      }

      // remove only one trailing [empty_line]
      const removedToken = cleaned.replace(
        /\[empty_line\]\s*$/i,
        ""
      );

      if (removedToken !== cleaned) {
        cleaned = removedToken.trim();
        changed = true;
      }
    }

    return cleaned;
  };

  const fetchAboutPage = async (id) => {
    try {
      const response = await getAboutPage(id);
      const resData = response?.data;
      setAboutTitle(resData?.data?.hero_section_title || "");
      setAboutDesc(resData?.data?.hero_section_desc || "");
      setWhyStudyInSection0Title(resData?.data?.why_study_in_title || "");
      setAboutSection0Title(resData?.data?.about_title || "");
      setAboutButtonDesc(resData?.data?.button_desc || "");
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image2: resData?.data?.hero_section_image,
        }));
      }

      if (
        resData?.data?.quick_states_highlights &&
        resData?.data?.quick_states_highlights.length > 0
      ) {
        // setKeyValues1(resData?.data?.quick_states_highlights);
        setKeyValues1(
          resData?.data?.quick_states_highlights?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setKeyValues1([]);
      }

      if (
        resData?.data?.why_study_in &&
        resData?.data?.why_study_in.length > 0
      ) {
        // setKeyValues2(resData?.data?.why_study_in);
        setKeyValues2(
          resData?.data?.why_study_in?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setKeyValues2([]);
      }

      setAboutShortDesc(resData?.data?.about_desc);

      if (
        resData?.data?.about_image !== "" &&
        resData?.data?.about_image !== null &&
        resData?.data?.about_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image3: resData?.data?.about_image,
        }));
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const fetchStudyProgramPage = async (id) => {
    try {
      const response = await getStudyPage(id);
      const resData = response?.data;
      setStudyTitle(resData?.data?.hero_section_title || "");
      setStudyDesc(resData?.data?.hero_section_desc || "");
      setStudyButtonDesc(resData?.data?.button_desc || "");
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image4: resData?.data?.hero_section_image,
        }));
      }

      if (resData?.data?.advantages && resData?.data?.advantages?.length > 0) {
        // setKeyValues3(resData?.data?.advantages);
        setKeyValues3(
          resData?.data?.advantages?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setKeyValues3([{ key: "", value: "", url: "", id: new Date().getTime() }]);
      }

      setAboutSection1Title(resData?.data?.about_title || "");
      setAdvantagesTitle(resData?.data?.advantages_title || "");

      setUniversitySectionTitle(resData?.data?.university_docs_title || "");
      setUniversitySectionTitleDesc(resData?.data?.university_docs_desc || "");
      setUniversitySectionTitleShortDesc(resData?.data?.university_docs_short_desc || "");
      // setUniversitySectionDocuments(resData?.data?.university_documents || "");

      if (resData?.data?.university_docs_list && resData?.data?.university_docs_list?.length > 0) {
        // setKeyValues6(resData?.data?.university_docs_list);
        setKeyValues6(
          resData?.data?.university_docs_list?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setKeyValues6([{ key: "", value: "", id: new Date().getTime() }]);
      }

      setStudyShortDesc(resData?.data?.about_desc);

      if (
        resData?.data?.about_image !== "" &&
        resData?.data?.about_image !== null &&
        resData?.data?.about_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image5: resData?.data?.about_image,
        }));
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const fetchCourseFinderPage = async (id) => {
    try {
      const response = await getCourseFinderPage(id);
      const resData = response?.data;
      setCourseFinderTitle(resData?.data?.hero_section_title || "");
      setCourseFinderDesc(resData?.data?.hero_section_desc || "");
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image15: resData?.data?.hero_section_image,
        }));
      }

      setCourseFinderShortDesc(resData?.data?.about_desc);
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const fetchPartTimeJobPage = async (id) => {
    try {
      const response = await getJobPage(id);
      const resData = response?.data;
      setPartTimeTitle(resData?.data?.hero_section_title || "");
      setPartTimeDesc(resData?.data?.hero_section_desc || "");
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image6: resData?.data?.hero_section_image,
        }));
      }

      setPartTimeShortDesc(resData?.data?.about_desc);

      if (
        resData?.data?.about_image !== "" &&
        resData?.data?.about_image !== null &&
        resData?.data?.about_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image7: resData?.data?.about_image,
        }));
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const fetchFinanceSupportPage = async (id) => {
    try {
      const response = await getSupportPage(id);
      const resData = response?.data;
      setFinanceTitle(resData?.data?.hero_section_title || "");
      setFinanceDesc(resData?.data?.hero_section_desc || "");
      setFianceSupportYoutubeTitle(resData?.data?.youtube_title || "");
      setFianceSupportYoutubeDesc(resData?.data?.youtube_desc || "");
      setFianceSupportYoutubeLink(resData?.data?.youtube_link || "");
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image8: resData?.data?.hero_section_image,
        }));
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const videoHandler = (e) => {
    const files = Array.from(e.target.files);
    setVideos((prev) => [...prev, ...files]);
  };

  const removeVideo = (index) => {
    setVideos(videos.filter((_, i) => i !== index));
  };

  const fetchBlockOpenAccountPage = async (id) => {
    try {
      const response = await getBankAccountPage(id);
      const resData = response.data;
      setBlockOpenAccountTitle(resData?.data?.hero_section_title || "");
      setBlockOpenAccountDesc(resData?.data?.hero_section_desc || "");
      if (resData?.data?.video_links) {
        setExistingVideos(resData?.data?.video_links); // array of URLs
      }
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image9: resData?.data?.hero_section_image,
        }));
      }

      if (resData?.data?.features && resData?.data?.features?.length > 0) {
        // setKeyValues4(resData?.data?.features);
        setKeyValues4(
          resData?.data?.features?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setKeyValues4([]);
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const fetchAccomationPage = async (id) => {
    try {
      const response = await getAccommodationPage(id);
      const resData = response?.data;
      setAccomationTitle(resData?.data?.hero_section_title || "");
      setAccomationDesc(resData?.data?.hero_section_desc || "");
      setAccomationAboutDesc(resData?.data?.about_desc || "");
      setAccomationYoutubeTitle(resData?.data?.youtube_title || "");
      setAccomationYoutubeDesc(resData?.data?.youtube_desc || "");
      setAccomationYoutubeLink(resData?.data?.youtube_link || "");
      setAccomationDocuments(resData?.data?.documents || "");
      setAccomationDetailsDesc(resData?.data?.details_desc || "");
      if (resData?.data?.details && resData?.data?.details?.length > 0) {
        // setAccomationDetails(resData?.data?.details);
        setAccomationDetails(
          resData?.data?.details?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setAccomationDetails([{ title: "", desc: "", image: "", badge: "", url: "", id: new Date().getTime() }]);
      }
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image10: resData?.data?.hero_section_image,
        }));
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const fetchForexExchangePage = async (id) => {
    try {
      const response = await getForexExchangePage(id);
      const resData = response?.data;
      setForexTitle(resData?.data?.hero_section_title || "");
      setForexDesc(resData?.data?.hero_section_desc || "");
      setForexAboutTitle(resData?.data?.about_title || "");
      setForexAboutDesc(resData?.data?.about_desc || "");
      setForexAboutShortDesc(resData?.data?.about_short_desc || "");
      setForexYoutubeTitle(resData?.data?.youtube_title || "");
      setForexYoutubeDesc(resData?.data?.youtube_desc || "");
      setForexYoutubeLink(resData?.data?.youtube_link || "");
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image11: resData?.data?.hero_section_image,
        }));
      }
      if (resData?.data?.features && resData?.data?.features?.length > 0) {
        // setKeyValues5(resData?.data?.features);
        setKeyValues5(
          resData?.data?.features?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setKeyValues5([]);
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const fetchVisaAppointmentPage = async (id) => {
    try {
      const response = await getVisaAppointmentPage(id);
      const resData = response?.data;
      setVisaAppoinmentTitle(resData?.data?.hero_section_title || "");
      setVisaAppoinmentDesc(resData?.data?.hero_section_desc || "");
      setVisaAppointmentSectionTitle(resData?.data?.about_title || "");
      setVisaAppointmentSectionDesc(resData?.data?.about_desc || "");
      setVisaAppointmentDocTitle(resData?.data?.doc_title || "");
      setVisaAppointmentDocDesc(resData?.data?.doc_desc || "");
      if (resData?.data?.docs_list && resData?.data?.docs_list.length > 0) {
        // setKeyValues8(resData.data.docs_list);
        setKeyValues8(
          resData?.data?.docs_list?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setKeyValues8([{ key: "", value: "", id: new Date().getTime() }]); // always keep one row
      }
      setVisaAppointmentApplicationTitle(resData?.data?.application_title || "");
      setVisaAppointmentApplicationDesc(resData?.data?.application_desc || "");
      setVisaAppoinmentYoutubeTitle(resData?.data?.youtube_title || "");
      setVisaAppoinmentYoutubeDesc(resData?.data?.youtube_desc || "");
      setVisaAppoinmentYoutubeLink(resData?.data?.youtube_link || "");
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image12: resData?.data?.hero_section_image,
        }));
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  const fetchVisaDocumentPage = async (id) => {
    try {
      const response = await getVisaDocumentPage(id);
      const resData = response?.data;
      setVisaDocumentTitle(resData?.data?.hero_section_title || "");
      setVisaDocumentDesc(resData?.data?.hero_section_desc || "");
      setVisaDocumentYoutubeTitle(resData?.data?.youtube_title || "");
      setVisaDocumentYoutubeDesc(resData?.data?.youtube_desc || "");
      setVisaDocumentYoutubeLink(resData?.data?.youtube_link || "");
      if (
        resData?.data?.hero_section_image !== "" &&
        resData?.data?.hero_section_image !== null &&
        resData?.data?.hero_section_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image13: resData?.data?.hero_section_image,
        }));
      }
      setVisaDocumentSectionTitle(resData?.data?.doc_title || "");
      setVisaDocumentSectionDesc(resData?.data?.doc_desc || "");

      if (resData?.data?.docs_list && resData?.data?.docs_list?.length > 0) {
        // setKeyValues7(resData?.data?.docs_list);
        setKeyValues7(
          resData?.data?.docs_list?.map((item, index) => ({
            ...item,
            id: `${Date.now()}_${index}`
          }))
        );
      } else {
        setKeyValues7([{ key: "", value: "" }]);
      }

      setVisaDocumentDoDontTitle(resData?.data?.do_dont_title || "");
      setVisaDocumentDoDontDesc(resData?.data?.do_dont_desc || "");
      setVisaDocumentAfterTitle(resData?.data?.after_title || "");
      setVisaDocumentAfterDesc(resData?.data?.after_desc || "");

      if (resData?.data?.doc_image !== "" &&
        resData?.data?.doc_image !== null &&
        resData?.data?.doc_image !== undefined
      ) {
        setFiles((prev) => ({
          ...prev,
          image16: resData?.data?.doc_image,
        }));
      }
    } catch (err) {
      console.error("Error fetching country:", err);
    }
  };

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchCountry = async () => {
        try {
          setLoading(true);
          const response = await getCountryById(id);
          const country = response?.data;
          setAddedCountryId(country?.data?.id);
          setCountryName(country?.data?.name);
          setCountryShowOnHome(country?.data?.show_on_home == 1 ? true : false);
          if (
            country.data?.image !== "" &&
            country.data?.image !== null &&
            country.data?.image !== undefined
          ) {
            setFiles({
              image1: country.data?.image_url, // only set image1
              image14: country.data?.home_image_url,
            });
          }
          setcoutryAdd(true);
          fetchAboutPage(country?.data?.id);
          fetchStudyProgramPage(country?.data?.id);
          fetchCourseFinderPage(country?.data?.id);
          fetchPartTimeJobPage(country?.data?.id);
          fetchFinanceSupportPage(country?.data?.id);
          fetchBlockOpenAccountPage(country?.data?.id);
          fetchAccomationPage(country?.data?.id);
          fetchForexExchangePage(country?.data?.id);
          fetchVisaAppointmentPage(country?.data?.id);
          fetchVisaDocumentPage(country?.data?.id);
        } catch (err) {
          console.error("Error fetching country:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchCountry();
    }
  }, [id]);

  const validateForm = () => {
    const newErrors = {};

    if (!countryName.trim()) {
      newErrors.countryName = "Country name is required";
    }

    if (!files["image1"]) {
      newErrors.image1 = "Please select country flag image";
    }

    if (!files["image14"]) {
      newErrors.image14 = "Please select country home image";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const validateSection0 = () => {
    const section0Errors = {};

    if (addedCountryId && !files["image2"]) {
      section0Errors.image2 = "About Page Hero Section Image is required";
    }

    if (addedCountryId && !files["image3"]) {
      section0Errors.image3 = `About ${countryName} Image is required`;
    }

    const strippedTitle = aboutTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section0Errors.aboutTitle = "About Page Hero Section Title is required";
    }

    const strippedDesc = aboutDesc.replace(/<[^>]*>/g, "").trim();

    // if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
    //   section0Errors.aboutDesc =
    //     "About Page Hero Section Description is required";
    // }

    // if (addedCountryId && !aboutShortDesc.trim()) {
    //   section0Errors.aboutShortDesc = `About ${countryName} Description is required`;
    // }

    if (addedCountryId) {
      keyValues1.forEach((pair, index) => {
        if (!pair.key.trim() || !pair.value.trim()) {
          section0Errors[`keyValues1_${index}`] =
            "Both Title and Description are required";
        }
      });
    }

    if (addedCountryId) {
      keyValues2.forEach((pair, index) => {
        if (!pair.key.trim() || !pair.value.trim()) {
          section0Errors[`keyValues2_${index}`] =
            "Both Title and Description are required";
        }
      });
    }

    setErrors((prev) => ({
      ...prev,
      section0: section0Errors,
    }));

    return Object.keys(section0Errors).length === 0;
  };

  const validateSection1 = () => {
    const section1Errors = {};

    if (addedCountryId && !files["image4"]) {
      section1Errors.image4 = "Hero Section Image is required";
    }

    if (addedCountryId && !files["image5"]) {
      section1Errors.image5 = `About Study In ${countryName} Image is required`;
    }

    const strippedTitle = studyTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section1Errors.studyTitle = "Hero Section Title is required";
    }

    const strippedDesc = studyDesc.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
      section1Errors.studyDesc = "Hero Section Description is required";
    }

    // if (addedCountryId) {
    //   keyValues3.forEach((pair, index) => {
    //     if (!pair.key.trim() || !pair.value.trim()) {
    //       section1Errors[`keyValues3_${index}`] =
    //         "Both Title and Description are required";
    //     }
    //   });
    // }

    if (addedCountryId && !studyShortDesc.trim()) {
      section1Errors.studyShortDesc = `About Study In ${countryName} Description is required`;
    }

    setErrors((prev) => ({
      ...prev,
      section1: section1Errors,
    }));

    return Object.keys(section1Errors).length === 0;
  };

  const validateSection2 = () => {
    const section2Errors = {};

    if (addedCountryId && !files["image6"]) {
      section2Errors.image6 = "Hero Section Image is required";
    }

    if (addedCountryId && !files["image7"]) {
      section2Errors.image7 = `About Part Time Job In ${countryName} Image is required`;
    }

    const strippedTitle = partTimeTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section2Errors.partTimeTitle = "Hero Section Title is required";
    }

    const strippedDesc = partTimeDesc.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
      section2Errors.partTimeDesc = "Hero Section Description is required";
    }

    if (addedCountryId && !partTimeShortDesc.trim()) {
      section2Errors.partTimeShortDesc = `About Part Time Job In ${countryName} Description is required`;
    }

    setErrors((prev) => ({
      ...prev,
      section2: section2Errors,
    }));

    return Object.keys(section2Errors).length === 0;
  };

  const validateSection3 = () => {
    const section3Errors = {};

    if (addedCountryId && !files["image8"]) {
      section3Errors.image8 = "Hero Section Image is required";
    }

    const strippedTitle = financeTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section3Errors.financeTitle = "Hero Section Title is required";
    }

    const strippedDesc = financeDesc.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
      section3Errors.financeDesc = "Hero Section Description is required";
    }

    setErrors((prev) => ({
      ...prev,
      section3: section3Errors,
    }));

    return Object.keys(section3Errors).length === 0;
  };

  const validateSection4 = () => {
    const section4Errors = {};

    if (addedCountryId && !files["image9"]) {
      section4Errors.image9 = "Hero Section Image is required";
    }

    const strippedTitle = blockOpenAccountTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section4Errors.blockOpenAccountTitle = "Hero Section Title is required";
    }

    const strippedDesc = blockOpenAccountDesc.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
      section4Errors.blockOpenAccountDesc =
        "Hero Section Description is required";
    }

    if (addedCountryId) {
      keyValues4.forEach((pair, index) => {
        if (!pair.key.trim()) {
          section4Errors[`keyValues4_${index}`] = "Title is required";
        }
      });
    }

    setErrors((prev) => ({
      ...prev,
      section4: section4Errors,
    }));

    return Object.keys(section4Errors).length === 0;
  };

  const validateSection5 = () => {
    const section5Errors = {};

    if (addedCountryId && !files["image10"]) {
      section5Errors.image10 = "Hero Section Image is required";
    }

    const strippedTitle = accomationTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section5Errors.accomationTitle = "Hero Section Title is required";
    }

    const strippedDesc = accomationDesc.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
      section5Errors.accomationDesc = "Hero Section Description is required";
    }

    setErrors((prev) => ({
      ...prev,
      section5: section5Errors,
    }));

    return Object.keys(section5Errors).length === 0;
  };

  const validateSection6 = () => {
    const section6Errors = {};

    if (addedCountryId && !files["image11"]) {
      section6Errors.image11 = "Hero Section Image is required";
    }

    const strippedTitle = forexTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section6Errors.forexTitle = "Hero Section Title is required";
    }

    const strippedDesc = forexDesc.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
      section6Errors.forexDesc = "Hero Section Description is required";
    }

    if (addedCountryId) {
      keyValues5.forEach((pair, index) => {
        if (!pair.key.trim() || !pair.value.trim()) {
          section6Errors[`keyValues5_${index}`] =
            "Both Title and Description are required";
        }
      });
    }

    setErrors((prev) => ({
      ...prev,
      section6: section6Errors,
    }));

    return Object.keys(section6Errors).length === 0;
  };

  const validateSection7 = () => {
    const section7Errors = {};

    if (addedCountryId && !files["image12"]) {
      section7Errors.image12 = "Hero Section Image is required";
    }

    const strippedTitle = visaAppoinmentTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section7Errors.visaAppoinmentTitle = "Hero Section Title is required";
    }

    const strippedDesc = visaAppoinmentDesc.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
      section7Errors.visaAppoinmentDesc =
        "Hero Section Description is required";
    }

    setErrors((prev) => ({
      ...prev,
      section7: section7Errors,
    }));

    return Object.keys(section7Errors).length === 0;
  };

  const validateSection8 = () => {
    const section8Errors = {};

    if (addedCountryId && !files["image13"]) {
      section8Errors.image13 = "Hero Section Image is required";
    }

    const strippedTitle = visaDocumentTitle.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedTitle) || strippedTitle.length === 0) {
      section8Errors.visaDocumentTitle = "Hero Section Title is required";
    }

    const strippedDesc = visaDocumentDesc.replace(/<[^>]*>/g, "").trim();

    if ((addedCountryId && !strippedDesc) || strippedDesc.length === 0) {
      section8Errors.visaDocumentDesc = "Hero Section Description is required";
    }

    setErrors((prev) => ({
      ...prev,
      section8: section8Errors,
    }));

    return Object.keys(section8Errors).length === 0;
  };

  const [files, setFiles] = React.useState({});
  const [previews, setPreviews] = React.useState({}); // 👈 ADD

  useEffect(() => {
    return () => {
      Object.values(previews).forEach((url) => {
        if (url) URL.revokeObjectURL(url);
      });
    };
  }, [previews]);

  const fileHandler = (e, key) => {
    const file = e.target.files[0];

    if (!file) return;

    // Remove old preview
    if (previews[key]) {
      URL.revokeObjectURL(previews[key]);
    }

    const previewUrl = URL.createObjectURL(file);

    setFiles((prev) => ({
      ...prev,
      [key]: file,
    }));

    setPreviews((prev) => ({
      ...prev,
      [key]: previewUrl,
    }));
  };

  const handleSave = async () => {
    try {
      // --- VALIDATE FORMS ---
      const formValid = validateForm();
      if (!formValid) return;

      if (coutryAdd) {
        // --- UPDATE COUNTRY FIRST ---
        setLoading(true);
        const countryFormData = new FormData();
        countryFormData.append("name", countryName);
        countryFormData.append("show_on_home", countryShowOnHome);
        if (files["image1"]) countryFormData.append("file", files["image1"]);
        if (files["image14"])
          countryFormData.append("home_image", files["image14"]);

        await updateCountry(addedCountryId, countryFormData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Country details updated successfully",
        });
        // navigate("/country");
      } else {
        // --- CREATE COUNTRY FIRST ---
        setLoading(true);
        const countryFormData = new FormData();
        countryFormData.append("name", countryName);
        if (files["image1"]) countryFormData.append("file", files["image1"]);
        if (files["image14"])
          countryFormData.append("home_image", files["image14"]);

        const response = await addCountry(countryFormData);
        if (response.data.success) {
          setcoutryAdd(true);
          setAddedCountryId(response.data.data.id);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Country added successfully",
          });
        }
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Operation failed",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAboutusPageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection0();
    if (!formValid) return;

    // --- UPDATE COUNTRY FIRST ---
    setLoading(true);

    // --- ABOUT PAGE DATA ---
    const aboutPageData = {
      hero_section_title: aboutTitle,
      hero_section_desc: aboutDesc,
      hero_section_image: files["image2"],
      quick_states_highlights: JSON.stringify(keyValues1),
      why_study_in_title: whyStudyInSection0Title,
      why_study_in: JSON.stringify(keyValues2),
      about_title: aboutSection0Title,
      about_desc: aboutShortDesc,
      button_desc: aboutButtonDesc,
      about_image: files["image3"],
      country_id: addedCountryId,
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(aboutPageData).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    // --- CALL ABOUT PAGE SERVICE ---
    try {
      await createAboutPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "About page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating About page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update About page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleStudyProgramPageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection1();
    if (!formValid) return;

    // --- UPDATE COUNTRY FIRST ---
    setLoading(true);
    // --- STUDY PAGE DATA ---
    const studyPage = {
      hero_section_title: studyTitle,
      hero_section_desc: studyDesc,
      hero_section_image: files["image4"],
      advantages_title: advantagesTitle,
      advantages: JSON.stringify(keyValues3),
      about_title: aboutSection1Title,
      about_desc: studyShortDesc,
      button_desc: studyButtonDesc,
      about_image: files["image5"],
      country_id: addedCountryId,
      university_docs_title: universitySectionTitle,
      university_docs_desc: universitySectionTitleDesc,
      university_docs_short_desc: universitySectionTitleShortDesc,
      university_docs_list: JSON.stringify(keyValues6),
      // university_documents: universitySectionDocuments
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(studyPage).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    // --- CALL STUDY PAGE SERVICE ---
    try {
      await createStudyPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Study program page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating Study program page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Study program page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCourseFindPageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection1();
    if (!formValid) return;

    // --- UPDATE COUNTRY FIRST ---
    setLoading(true);
    // --- STUDY PAGE DATA ---
    const studyPage = {
      hero_section_title: courseFinderTitle,
      hero_section_desc: courseFinderDesc,
      hero_section_image: files["image15"],
      about_desc: courseFinderShortDesc,
      country_id: addedCountryId,
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(studyPage).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    // --- CALL STUDY PAGE SERVICE ---
    try {
      await createCourseFinderPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Course Finder page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating Course Finder page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Course Finder page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePartTimePageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection2();
    if (!formValid) return;

    // --- UPDATE COUNTRY FIRST ---
    setLoading(true);

    // --- PART-TIME / JOB PAGE DATA ---
    const partTimePageData = {
      hero_section_title: partTimeTitle,
      hero_section_desc: partTimeDesc,
      hero_section_image: files["image6"],
      about_desc: partTimeShortDesc,
      about_image: files["image7"],
      country_id: addedCountryId,
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(partTimePageData).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    // --- CALL JOB PAGE SERVICE ---
    try {
      await createJobPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Part time page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating Part time page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Part time page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleFinanceSupportPageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection3();
    if (!formValid) return;

    setLoading(true);
    // --- FINANCE / SUPPORT PAGE DATA ---
    const supportPageData = {
      hero_section_title: financeTitle,
      hero_section_desc: financeDesc,
      hero_section_image: files["image8"],
      youtube_title: financeSupportYoutubeTitle,
      youtube_desc: financeSupportYoutubeDesc,
      youtube_link: financeSupportYoutubeLink,
      country_id: addedCountryId,
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(supportPageData).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    // --- CALL SUPPORT PAGE SERVICE ---
    try {
      await createSupportPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Finance support page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating Finance support page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Finance support page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleBlockOpenAccountPageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection4();
    if (!formValid) return;
    setLoading(true);
    // --- BLOCK OPEN ACCOUNT PAGE DATA ---
    const bankAccountPageData = {
      hero_section_title: blockOpenAccountTitle,
      hero_section_desc: blockOpenAccountDesc,
      hero_section_image: files["image9"],
      hero_section_features: JSON.stringify(keyValues4),
      country_id: addedCountryId,
      about_title: bankAboutTitle,
      about_desc: bankAboutDesc
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(bankAccountPageData).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    if (videos && videos.length > 0) {
      videos.forEach((video) => {
        formData.append("videos", video);
      });
    }

    // --- CALL BANK ACCOUNT PAGE SERVICE ---
    try {
      await createBankAccountPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Block open A/C page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating Block open A/C page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Block open A/C page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAccommodationPageSave = async () => {
    const formValid = validateSection5();
    if (!formValid) return;

    setLoading(true);

    try {
      const formData = new FormData();

      // 🔹 Append normal fields
      formData.append("hero_section_title", accomationTitle);
      formData.append("hero_section_desc", accomationDesc);
      formData.append("youtube_title", accomationYoutubeTitle);
      formData.append("youtube_desc", accomationYoutubeDesc);
      formData.append("youtube_link", accomationYoutubeLink);
      formData.append("about_desc", accomationAboutDesc);
      formData.append("documents", accomationDocuments);
      formData.append("country_id", addedCountryId);
      formData.append("details_desc", accomationDetailsDesc);

      if (files["image10"]) {
        formData.append("hero_section_image", files["image10"]);
      }

      // 🔥 HANDLE DETAILS (LIKE FEATURES)
      const finalDetails = [];

      accomationDetails.forEach((item, index) => {
        if (item.image instanceof File) {
          // ✅ send with index
          formData.append(`detail_images[${index}]`, item.image);

          finalDetails.push({
            title: item.title,
            desc: item.desc,
            badge: item.badge,
            url: item.url,
            image: null, // backend will replace correctly
          });
        } else {
          finalDetails.push({
            title: item.title,
            desc: item.desc,
            badge: item.badge,
            url: item.url,
            image: item.image || null,
          });
        }
      });

      // 🔹 Append JSON
      formData.append("details", JSON.stringify(finalDetails));

      // 🔹 API Call
      await createAccommodationPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Find your accommodation page content updated successfully",
      });

    } catch (error) {
      console.error("Error updating accommodation page:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Find your accommodation page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleForexExchangePageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection6();
    if (!formValid) return;

    setLoading(true);

    // --- ACCOMMODATION PAGE DATA ---
    const forexPageData = {
      hero_section_title: forexTitle,
      hero_section_desc: forexDesc,
      hero_section_image: files["image11"],
      youtube_title: forexYoutubeTitle,
      youtube_desc: forexYoutubeDesc,
      youtube_link: forexYoutubeLink,
      features: JSON.stringify(keyValues5),
      country_id: addedCountryId,
      about_title: forexAboutTitle,
      about_desc: forexAboutDesc,
      about_short_desc: forexAboutShortDesc,
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(forexPageData).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    // --- CALL FOREX EXCHANGE PAGE SERVICE ---
    try {
      await createForexExchangePage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Forex exchange page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating Forex exchange page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Forex exchange page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleVisaAppointmentPageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection7();
    if (!formValid) return;

    setLoading(true);

    // --- VISA APPOINTMENT PAGE DATA ---
    const visaAppointmentPageData = {
      hero_section_title: visaAppoinmentTitle,
      hero_section_desc: visaAppoinmentDesc,
      youtube_title: visaAppoinmentYoutubeTitle,
      youtube_desc: visaAppoinmentYoutubeDesc,
      youtube_link: visaAppoinmentYoutubeLink,
      hero_section_image: files["image12"],
      country_id: addedCountryId,
      about_title: visaAppointmentSectionTitle,
      about_desc: visaAppointmentSectionDesc,
      doc_title: visaAppointmentDocTitle,
      doc_desc: visaAppointmentDocDesc,
      docs_list: JSON.stringify(keyValues8),
      application_title: visaAppointmentApplicationTitle,
      application_desc: visaAppointmentApplicationDesc,
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(visaAppointmentPageData).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    // --- CALL VISA APPOINTMENT PAGE SERVICE ---
    try {
      await createVisaAppointmentPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Visa appointment page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating visa appointment page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update visa appointment page content",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleVisaDocumentPageSave = async () => {
    // --- VALIDATE FORMS ---
    const formValid = validateSection8();
    if (!formValid) return;

    setLoading(true);

    // --- VISA DOCUMENT PAGE DATA ---
    const visaDocumentPageData = {
      hero_section_title: visaDocumentTitle,
      hero_section_desc: visaDocumentDesc,
      youtube_title: visaDocumentYoutubeTitle,
      youtube_desc: visaDocumentYoutubeDesc,
      youtube_link: visaDocumentYoutubeLink,
      hero_section_image: files["image13"],
      country_id: addedCountryId,
      doc_title: visaDocumentSectionTitle,
      doc_desc: visaDocumentSectionDesc,
      docs_list: JSON.stringify(keyValues7),
      doc_image: files["image16"],
      do_dont_title: visaDocumentDoDontTitle,
      do_dont_desc: visaDocumentDoDontDesc,
      after_title: visaDocumentAfterTitle,
      after_desc: visaDocumentAfterDesc,
    };

    // --- CREATE FORM DATA ---
    const formData = new FormData();
    Object.entries(visaDocumentPageData).forEach(([key, val]) => {
      if (val !== undefined && val !== null) {
        formData.append(key, val);
      }
    });

    // --- CALL VISA DOCUMENT PAGE SERVICE ---
    try {
      await createVisaDocumentPage(formData);

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Visa document page content updated successfully",
      });
    } catch (error) {
      console.error("Error updating Visa document page content:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update Visa document page content",
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Country" : "Add Country"}`}
        motherMenu="Country"
        activeMenuLink={`${id ? `edit-country/${id}` : "add-country"}`}
        motherMenuLink={"country"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form>
                    <div
                      onClick={() => {
                        navigate("/country");
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Country List</div>
                    </div>
                    <div className="d-flex flex-column flex-lg-row gap-2">
                      <div>
                        <label className="form-label fw-semibold">
                          Country Flag Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-0">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image1"]
                                    ? `url(${previews["image1"]})`
                                    : files["image1"]
                                      ? `url(${files["image1"]})`
                                      : `url(${NoImage})`,
                                  // backgroundImage: files["image1"]
                                  //   ? `url(${files["image1"] instanceof File
                                  //     ? URL.createObjectURL(files["image1"])
                                  //     : files["image1"]
                                  //   })`
                                  //   : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image1")}
                                id="imageUpload"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.image1 && (
                          <div className="text-danger mt-1 mb-3">
                            {errors.image1}
                          </div>
                        )}
                      </div>
                      <div>
                        <label className="form-label fw-semibold">
                          Country Home Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-0">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview14"
                                style={{
                                  backgroundImage: previews["image14"]
                                    ? `url(${previews["image14"]})`
                                    : files["image14"]
                                      ? `url(${files["image14"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image14")}
                                id="imageUpload14"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload14"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.image14 && (
                          <div className="text-danger mt-1 mb-3">
                            {errors.image14}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 mt-3">
                      <label className="form-label fw-semibold">Name</label>
                      <input
                        type="text"
                        className={`form-control w-full ${errors.countryName ? "is-invalid" : ""
                          }`}
                        placeholder="Name"
                        value={countryName} // bind value
                        onChange={(e) => setCountryName(e.target.value)} // update state
                      />
                      {errors.countryName && (
                        <div className="invalid-feedback mt-1">
                          {errors.countryName}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <div className="form-check mb-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="show_on_home_page"
                          checked={countryShowOnHome}
                          onChange={(e) =>
                            setCountryShowOnHome(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="show_on_home_page"
                        >
                          Show on Home Page
                        </label>
                      </div>
                    </div>
                    <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                    <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                      <Button
                        type="button"
                        variant="secondary"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => {
                          // navigate("/country"); // Close the collapse
                          navigate("/country", {
                            state: {
                              page: location.state?.page || 1,
                              searchTerm: location.state?.searchTerm || "",
                            },
                          });
                        }}
                      >
                        Back
                      </Button>
                      <Button
                        className="btn btn-primary btn-sm"
                        onClick={handleSave}
                      >
                        {coutryAdd ? "Update" : "Save"}
                      </Button>
                    </div>
                  </form>
                </div>
              </div>
              {coutryAdd && !state.section0 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section0 && Object.keys(errors.section0).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase0" })}
                  >
                    <div className="cpa">
                      <b>{countryName}</b> &nbsp;Overview Page Content
                    </div>
                    <div className="tools d-flex align-items-center gap-2">
                      {!state.collpase0 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-black">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  <Collapse in={state.collpase0}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          About Page Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image2"]
                                    ? `url(${previews["image2"]})`
                                    : files["image2"]
                                      ? `url(${files["image2"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image2")}
                                id="imageUpload1"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload1"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section0?.image2 && (
                          <div className="text-danger mb-3">
                            {errors.section0?.image2}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Page Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(aboutTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAboutTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={aboutTitle}
                                onChange={(val) => setAboutTitle(val)}
                                error={errors.section0?.aboutTitle}
                              /> */}
                            </div>
                            {errors.section0?.aboutTitle && (
                              <div className="text-danger mb-3">
                                {errors.section0?.aboutTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Page Hero Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(aboutDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAboutDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={aboutDesc}
                                onChange={(val) => setAboutDesc(val)}
                                error={errors.section0?.aboutDesc}
                              /> */}
                            </div>
                            {errors.section0?.aboutDesc && (
                              <div className="text-danger mb-3">
                                {errors.section0?.aboutDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Page Button Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(aboutButtonDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAboutButtonDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={aboutButtonDesc}
                                onChange={(val) => setAboutButtonDesc(val)}
                                error={errors.section0?.aboutButtonDesc}
                              /> */}
                            </div>
                            {errors.section0?.aboutButtonDesc && (
                              <div className="text-danger mb-3">
                                {errors.section0?.aboutButtonDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Dynamic Key-Value Pairs */}
                        <div className="row mb-3">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Page Hero Section Quick State Highlights
                            </label>
                            {keyValues1.map((pair, index) => (
                              <div
                                key={pair.id || index}
                                className="position-relative border rounded p-3 mb-3"
                              >
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
                                  onClick={() => {
                                    const newKV = keyValues1.filter(
                                      (_, i) => i !== index
                                    );
                                    setKeyValues1(newKV);
                                  }}
                                >
                                  ✕
                                </button>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Title
                                  </label>
                                  <textarea
                                    placeholder="Enter Title"
                                    className={`form-control me-2 ${errors.section0?.[`keyValues1_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.key}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      setKeyValues1((prev) =>
                                        prev.map((item, i) =>
                                          i === index ? { ...item, key: value } : item
                                        )
                                      );
                                    }}
                                  ></textarea>
                                </div>
                                <div className="mb-3">
                                  <label className="form-label fw-semibold">
                                    Description
                                  </label>
                                  <textarea
                                    placeholder="Enter Description"
                                    className={`form-control me-2 ${errors.section0?.[`keyValues1_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.value}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      setKeyValues1((prev) =>
                                        prev.map((item, i) =>
                                          i === index ? { ...item, value: value } : item
                                        )
                                      );
                                    }}
                                  // onChange={(e) => {
                                  //   const newKV = [...keyValues1];
                                  //   newKV[index].value = e.target.value;
                                  //   setKeyValues1(newKV);
                                  // }}
                                  ></textarea>
                                </div>
                                {errors.section0?.[`keyValues1_${index}`] && (
                                  <div className="text-danger mt-1">
                                    {errors.section0[`keyValues1_${index}`]}
                                  </div>
                                )}
                              </div>
                            ))}
                            {errors.section0?.keyValues1 && (
                              <div className="text-danger mb-2">
                                {errors.section0?.keyValues1}
                              </div>
                            )}
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2 block"
                                onClick={() =>
                                  setKeyValues1([
                                    ...keyValues1,
                                    { key: "", value: "", id: new Date().getTime() },
                                  ])
                                }
                              >
                                + Add Title-Description
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Why Study In &nbsp; <b>{countryName}</b> &nbsp; Country Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(whyStudyInSection0Title).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setWhyStudyInSection0Title(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={whyStudyInSection0Title}
                                onChange={(val) => setWhyStudyInSection0Title(val)}
                                error={errors.section1?.whyStudyInSection0Title}
                              /> */}
                            </div>
                            {errors.section0?.whyStudyInSection0Title && (
                              <div className="text-danger mb-3">
                                {errors.section0?.whyStudyInSection0Title}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Dynamic Key-Value Pairs */}
                        <div className="row mb-3">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Why Study In &nbsp; <b>{countryName}</b> &nbsp; Country
                            </label>
                            {keyValues2.map((pair, index) => (
                              <div
                                key={pair.id || index}
                                className="position-relative border rounded p-3 mb-3"
                              >
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
                                  onClick={() => {
                                    const newKV = keyValues2.filter(
                                      (_, i) => i !== index
                                    );
                                    setKeyValues2(newKV);
                                  }}
                                >
                                  ✕
                                </button>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Title
                                  </label>
                                  <textarea
                                    placeholder="Enter Title"
                                    className={`form-control me-2 ${errors.section0?.[`keyValues2_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.key}
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      setKeyValues2((prev) =>
                                        prev.map((item, i) =>
                                          i === index ? { ...item, key: value } : item
                                        )
                                      );
                                    }}
                                  // onChange={(e) => {
                                  //   const newKV = [...keyValues2];
                                  //   newKV[index].key = e.target.value;
                                  //   setKeyValues2(newKV);
                                  // }}
                                  ></textarea>
                                </div>
                                <div className="mb-3">
                                  <label className="form-label fw-semibold">
                                    Description
                                  </label>
                                  <CKEditor
                                    editor={CustomClassicEditor}
                                    data={(pair.value).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                    onChange={(event, editor) => {
                                      const newKV = [...keyValues2];
                                      newKV[index].value = editor.getData();
                                      setKeyValues2(newKV);
                                    }}
                                  />
                                  {/* <CkEditorBlog
                                    value={pair.value}
                                    onChange={(val) => {
                                      const newKV = [...keyValues2];
                                      newKV[index].value = val;
                                      setKeyValues2(newKV);
                                    }}
                                    error={errors.section0?.[`keyValues2_${index}`]}
                                  /> */}
                                  {/* <textarea
                                    placeholder="Enter description"
                                    className={`form-control me-2 ${errors.section0?.[`keyValues2_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.value}
                                    onChange={(e) => {
                                      const newKV = [...keyValues2];
                                      newKV[index].value = e.target.value;
                                      setKeyValues2(newKV);
                                    }}
                                  ></textarea> */}
                                </div>
                                {/* {errors.section0?.[`keyValues2_${index}`] && (
                                  <div className="text-danger mt-1">
                                    {errors.section0[`keyValues2_${index}`]}
                                  </div>
                                )} */}
                              </div>
                            ))}
                            {errors.section0?.keyValues2 && (
                              <div className="text-danger mb-2">
                                {errors.section0?.keyValues2}
                              </div>
                            )}
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2"
                                onClick={() =>
                                  setKeyValues2([
                                    ...keyValues2,
                                    { key: "", value: "", id: new Date().getTime() },
                                  ])
                                }
                              >
                                + Add Title-Description
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About &nbsp; <b>{countryName}</b> &nbsp; Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(aboutSection0Title).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAboutSection0Title(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={aboutSection0Title}
                                onChange={(val) => setAboutSection0Title(val)}
                                error={errors.section1?.aboutSection0Title}
                              /> */}
                            </div>
                            {errors.section0?.aboutSection0Title && (
                              <div className="text-danger mb-3">
                                {errors.section0?.aboutSection0Title}
                              </div>
                            )}
                          </div>
                        </div>
                        <label className="form-label fw-semibold">
                          About &nbsp; <b>{countryName}</b> &nbsp; Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image3"]
                                    ? `url(${previews["image3"]})`
                                    : files["image3"]
                                      ? `url(${files["image3"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image3")}
                                id="imageUpload2"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload2"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section0?.image3 && (
                          <div className="text-danger mb-3">
                            {errors.section0?.image3}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About &nbsp; <b>{countryName}</b> &nbsp; Description
                            </label>
                            <CKEditor
                              editor={CustomClassicEditor}
                              data={(aboutShortDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                              onChange={(event, editor) => {
                                setAboutShortDesc(editor.getData());
                              }}
                            />
                            {/* <CkEditorBlog
                              value={aboutShortDesc}
                              onChange={(val) => setAboutShortDesc(val)}
                              error={errors.section0?.aboutShortDesc}
                            /> */}
                            {/* <textarea
                              className={`form-control ${errors.section0?.aboutShortDesc
                                ? "is-invalid"
                                : ""
                                }`}
                              placeholder="Enter description"
                              rows="2"
                              value={aboutShortDesc}
                              onChange={(e) =>
                                setAboutShortDesc(e.target.value)
                              }
                            ></textarea> */}
                          </div>
                          {/* {errors.section0?.aboutShortDesc && (
                            <div className="text-danger mb-3 mt-1">
                              {errors.section0?.aboutShortDesc}
                            </div>
                          )} */}
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase0" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handleAboutusPageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section1 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section1 && Object.keys(errors.section1).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase1" })}
                  >
                    <div className="cpa">
                      Study In &nbsp; <b>{countryName}</b> &nbsp; Page Content
                    </div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase1 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>

                  <Collapse in={state.collpase1}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image4"]
                                    ? `url(${previews["image4"]})`
                                    : files["image4"]
                                      ? `url(${files["image4"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image4")}
                                id="imageUpload3"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload3"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section1?.image4 && (
                          <div className="text-danger mb-3">
                            {errors.section1?.image4}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(studyTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setStudyTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={studyTitle}
                                onChange={(val) => setStudyTitle(val)}
                                error={errors.section1?.studyTitle}
                              /> */}
                            </div>
                            {errors.section1?.studyTitle && (
                              <div className="text-danger mb-3">
                                {errors.section1?.studyTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero section description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(studyDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setStudyDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={studyDesc}
                                onChange={(val) => setStudyDesc(val)}
                                error={errors.section1?.studyDesc}
                              /> */}
                            </div>
                            {errors.section1?.studyDesc && (
                              <div className="text-danger mb-3">
                                {errors.section1?.studyDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Advantages Why Study In &nbsp; <b>{countryName}</b> &nbsp; Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(advantagesTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAdvantagesTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={advantagesTitle}
                                onChange={(val) => setAdvantagesTitle(val)}
                                error={errors.section1?.advantagesTitle}
                              /> */}
                            </div>
                            {errors.section1?.advantagesTitle && (
                              <div className="text-danger mb-3">
                                {errors.section1?.advantagesTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Dynamic Key-Value Pairs */}
                        <div className="row mb-3">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Advantages Why Study In &nbsp; <b>{countryName}</b> &nbsp;
                              Country
                            </label>
                            {keyValues3.map((pair, index) => (
                              <div
                                key={pair.id || index}
                                className="position-relative border rounded p-3 mb-3"
                              >
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
                                  onClick={() => {
                                    const newKV = keyValues3.filter(
                                      (_, i) => i !== index
                                    );
                                    setKeyValues3(newKV);
                                  }}
                                >
                                  ✕
                                </button>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Title
                                  </label>
                                  <textarea
                                    placeholder="Enter Title"
                                    className={`form-control me-2 ${errors.section1?.[`keyValues3_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows="2"
                                    value={pair.key}
                                    onChange={(e) => {
                                      const newKV = keyValues3.map((item, i) =>
                                        i === index ? { ...item, key: e.target.value } : item
                                      );
                                      setKeyValues3(newKV);
                                    }}
                                  ></textarea>
                                </div>
                                <div className="mb-3">
                                  <label className="form-label fw-semibold">
                                    Description
                                  </label>
                                  <CKEditor
                                    editor={CustomClassicEditor}
                                    data={(pair.value).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                    onChange={(event, editor) => {
                                      const newKV = keyValues3.map((item, i) =>
                                        i === index ? { ...item, value: editor.getData() } : item
                                      );
                                      setKeyValues3(newKV);
                                    }}
                                  />
                                  {/* <textarea
                                    placeholder="Enter description"
                                    className={`form-control me-2 ${errors.section1?.[`keyValues3_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows="2"
                                    value={pair.value}
                                    onChange={(e) => {
                                      const newKV = [...keyValues3];
                                      newKV[index].value = e.target.value;
                                      setKeyValues3(newKV);
                                    }}
                                  ></textarea> */}
                                </div>
                                <div className="mb-3">
                                  <label className="form-label fw-semibold">
                                    URL
                                  </label>
                                  <textarea
                                    placeholder="Enter url"
                                    className={`form-control me-2 ${errors.section1?.[`keyValues3_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows="2"
                                    value={pair.url}
                                    onChange={(e) => {
                                      const newKV = [...keyValues3];
                                      newKV[index].url = e.target.value;
                                      setKeyValues3(newKV);
                                    }}
                                  ></textarea>
                                </div>
                                {errors.section1?.[`keyValues3_${index}`] && (
                                  <div className="text-danger mt-1">
                                    {errors.section1[`keyValues3_${index}`]}
                                  </div>
                                )}
                              </div>
                            ))}
                            {errors.section1?.keyValues3 && (
                              <div className="text-danger mb-2">
                                {errors.section1?.keyValues3}
                              </div>
                            )}
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2"
                                onClick={() =>
                                  setKeyValues3([
                                    ...keyValues3,
                                    { key: "", value: "", id: new Date().getTime() },
                                  ])
                                }
                              >
                                + Add Title-Description
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              {/* About Study In <b>{countryName}</b> Description */}
                              What is APS? Section Title
                            </label>
                            <CKEditor
                              editor={CustomClassicEditor}
                              data={(aboutSection1Title).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                              onChange={(event, editor) => {
                                setAboutSection1Title(editor.getData());
                              }}
                            />
                            {/* <CkEditorBlog
                              value={aboutSection1Title}
                              onChange={(val) => setAboutSection1Title(val)}
                              error={errors.section1?.aboutSection1Title}
                            /> */}
                          </div>
                        </div>
                        <label className="form-label fw-semibold">
                          {/* About Study In <b>{countryName}</b> Image */}
                          What is APS? Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image5"]
                                    ? `url(${previews["image5"]})`
                                    : files["image5"]
                                      ? `url(${files["image5"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image5")}
                                id="imageUpload4"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload4"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section1?.image5 && (
                          <div className="text-danger mb-3">
                            {errors.section1?.image5}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              {/* About Study In <b>{countryName}</b> Description */}
                              What is APS? content description
                            </label>
                            <CKEditor
                              editor={CustomClassicEditor}
                              data={(studyShortDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                              onChange={(event, editor) => {
                                setStudyShortDesc(editor.getData());
                              }}
                            />
                            {/* <CkEditorBlog
                              value={studyShortDesc}
                              onChange={(val) => setStudyShortDesc(val)}
                              error={errors.section1?.studyShortDesc}
                            /> */}
                            {/* <textarea
                              className={`form-control ${errors.section1?.studyShortDesc
                                ? "is-invalid"
                                : ""
                                }`}
                              placeholder="Enter description"
                              rows="2"
                              value={studyShortDesc}
                              onChange={(e) =>
                                setStudyShortDesc(e.target.value)
                              }
                            ></textarea>
                            {errors.section1?.studyShortDesc && (
                              <div className="text-danger mb-3 mt-1">
                                {errors.section1?.studyShortDesc}
                              </div>
                            )} */}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              {/* About Study In <b>{countryName}</b> Description */}
                              University Section Title
                            </label>
                            <CKEditor
                              editor={CustomClassicEditor}
                              data={(universitySectionTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                              onChange={(event, editor) => {
                                setUniversitySectionTitle(editor.getData());
                              }}
                            />
                            {/* <CkEditorBlog
                              value={universitySectionTitle}
                              onChange={(val) => setUniversitySectionTitle(val)}
                              error={errors.section1?.universitySectionTitle}
                            /> */}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              {/* About Study In <b>{countryName}</b> Description */}
                              University Section Description
                            </label>
                            <CKEditor
                              editor={CustomClassicEditor}
                              data={(universitySectionTitleDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                              onChange={(event, editor) => {
                                setUniversitySectionTitleDesc(editor.getData());
                              }}
                            />
                            {/* <CkEditorBlog
                              value={universitySectionTitleDesc}
                              onChange={(val) => setUniversitySectionTitleDesc(val)}
                              error={errors.section1?.universitySectionTitleDesc}
                            /> */}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              {/* About Study In <b>{countryName}</b> Description */}
                              University Section Short Description
                            </label>
                            <CKEditor
                              editor={CustomClassicEditor}
                              data={(universitySectionTitleShortDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                              onChange={(event, editor) => {
                                setUniversitySectionTitleShortDesc(editor.getData());
                              }}
                            />
                            {/* <CkEditorBlog
                              value={universitySectionTitleShortDesc}
                              onChange={(val) => setUniversitySectionTitleShortDesc(val)}
                              error={errors.section1?.universitySectionTitleShortDesc}
                            /> */}
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              University / Program Requirements
                            </label>
                            <CkEditorBlog
                              value={universitySectionDocuments}
                              onChange={(val) => setUniversitySectionDocuments(val)}
                              error={errors.section1?.universitySectionDocuments}
                            />
                          </div>
                        </div> */}
                        <div className="row mt-2">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              University / Program Requirements
                            </label>
                            {keyValues6.map((pair, index) => (
                              <div
                                key={pair.id || index}
                                className="position-relative border rounded p-3 mb-3"
                              >
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={() => {
                                    const newKV = keyValues6.filter(
                                      (_, i) => i !== index
                                    );
                                    setKeyValues6(newKV);
                                  }}
                                >
                                  ✕
                                </button>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Title
                                  </label>
                                  <textarea
                                    key={`keyValues6_title-${index}-${pair.key}`}
                                    placeholder="Enter Title"
                                    className={`form-control me-2 ${errors.section1?.[`keyValues6_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.key ?? ""}
                                    onChange={(e) => {
                                      const newKV = keyValues6.map((item, i) =>
                                        i === index ? { ...item, key: e.target.value } : item
                                      );
                                      setKeyValues6(newKV);
                                    }}
                                  ></textarea>
                                </div>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Description
                                  </label>
                                  <CKEditor
                                    editor={CustomClassicEditor}
                                    data={(pair.value).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                    onChange={(event, editor) => {
                                      const newKV = keyValues6.map((item, i) =>
                                        i === index ? { ...item, value: editor.getData() } : item
                                      );
                                      setKeyValues6(newKV);
                                    }}
                                  />
                                  {/* <CkEditorBlog
                                    value={pair.value}
                                    onChange={(val) => {
                                      const newKV = [...keyValues6];
                                      newKV[index].value = val;
                                      setKeyValues6(newKV);
                                    }}
                                  /> */}
                                </div>
                                {errors.section1?.[`keyValues6_${index}`] && (
                                  <div className="text-danger mt-1">
                                    {errors.section1[`keyValues6_${index}`]}
                                  </div>
                                )}
                              </div>
                            ))}
                            {errors.section1?.keyValues6 && (
                              <div className="text-danger mb-2">
                                {errors.section1?.keyValues6}
                              </div>
                            )}
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2"
                                onClick={() =>
                                  setKeyValues6([...keyValues6, { key: "", value: "", id: new Date().getTime() }])
                                }
                              >
                                + Add Title
                              </button>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase1" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handleStudyProgramPageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section9 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section9 && Object.keys(errors.section9).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase9" })}
                  >
                    <div className="cpa">
                      Course Finder Page Content
                    </div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase9 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>

                  <Collapse in={state.collpase9}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image15"]
                                    ? `url(${previews["image15"]})`
                                    : files["image15"]
                                      ? `url(${files["image15"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image15")}
                                id="imageUpload15"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload15"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section9?.image15 && (
                          <div className="text-danger mb-3">
                            {errors.section9?.image15}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(courseFinderTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setCourseFinderTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={courseFinderTitle}
                                onChange={(val) => setCourseFinderTitle(val)}
                                error={errors.section9?.courseFinderTitle}
                              /> */}
                            </div>
                            {errors.section9?.courseFinderTitle && (
                              <div className="text-danger mb-3">
                                {errors.section9?.courseFinderTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero section description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(courseFinderDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setCourseFinderDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={courseFinderDesc}
                                onChange={(val) => setCourseFinderDesc(val)}
                                error={errors.section9?.courseFinderDesc}
                              /> */}
                            </div>
                            {errors.section9?.courseFinderDesc && (
                              <div className="text-danger mb-3">
                                {errors.section9?.courseFinderDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Description
                            </label>
                            <CKEditor
                              editor={CustomClassicEditor}
                              data={(courseFinderShortDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                              onChange={(event, editor) => {
                                setCourseFinderShortDesc(editor.getData());
                              }}
                            />
                            {/* <CkEditorBlog
                              value={courseFinderShortDesc}
                              onChange={(val) => setCourseFinderShortDesc(val)}
                              error={errors.section9?.courseFinderShortDesc}
                            /> */}
                          </div>
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase9" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handleCourseFindPageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section3 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section3 && Object.keys(errors.section3).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase3" })}
                  >
                    <div className="cpa">Education Loan Support Page Content</div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase3 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  <Collapse in={state.collpase3}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image8"]
                                    ? `url(${previews["image8"]})`
                                    : files["image8"]
                                      ? `url(${files["image8"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image8")}
                                id="imageUpload7"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload7"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section3?.image8 && (
                          <div className="text-danger mb-3">
                            {errors.section3?.image8}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(financeTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setFinanceTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={financeTitle}
                                onChange={(val) => setFinanceTitle(val)}
                                error={errors.section3?.financeTitle}
                              /> */}
                            </div>
                            {errors.section3?.financeTitle && (
                              <div className="text-danger mb-3">
                                {errors.section3?.financeTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(financeDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setFinanceDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={financeDesc}
                                onChange={(val) => setFinanceDesc(val)}
                                error={errors.section3?.financeDesc}
                              /> */}
                            </div>
                            {errors.section3?.financeDesc && (
                              <div className="text-danger mb-3">
                                {errors.section3?.financeDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Title
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(financeSupportYoutubeTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setFianceSupportYoutubeTitle(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={financeSupportYoutubeTitle}
                            onChange={(val) => setFianceSupportYoutubeTitle(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Description
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(financeSupportYoutubeDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setFianceSupportYoutubeDesc(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={financeSupportYoutubeDesc}
                            onChange={(val) => setFianceSupportYoutubeDesc(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Link
                          </label>
                          <input
                            type="text"
                            className={`form-control w-full ${errors.section3?.financesupportYoutubeLink
                              ? "is-invalid"
                              : ""
                              }`}
                            placeholder="Youtube Link"
                            value={financeSupportYoutubeLink} // bind value
                            onChange={(e) =>
                              setFianceSupportYoutubeLink(e.target.value)
                            } // update state
                          />
                          {errors.section3?.financesupportYoutubeLink && (
                            <div className="invalid-feedback mt-1">
                              {errors.section3?.financesupportYoutubeLink}
                            </div>
                          )}
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase3" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handleFinanceSupportPageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section4 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section4 && Object.keys(errors.section4).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase4" })}
                  >
                    <div className="cpa">Blocked Account&nbsp; (<b>{countryName}</b>) &nbsp; Page Content</div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase4 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  <Collapse in={state.collpase4}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image9"]
                                    ? `url(${previews["image9"]})`
                                    : files["image9"]
                                      ? `url(${files["image9"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image9")}
                                id="imageUpload8"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload8"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section4?.image9 && (
                          <div className="text-danger mb-3">
                            {errors.section4?.image9}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(blockOpenAccountTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setBlockOpenAccountTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={blockOpenAccountTitle}
                                onChange={(val) =>
                                  setBlockOpenAccountTitle(val)
                                }
                                error={errors.section4?.blockOpenAccountTitle}
                              /> */}
                            </div>
                            {errors.section4?.blockOpenAccountTitle && (
                              <div className="text-danger mb-3">
                                {errors.section4?.blockOpenAccountTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(blockOpenAccountDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setBlockOpenAccountDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={blockOpenAccountDesc}
                                onChange={(val) => setBlockOpenAccountDesc(val)}
                                error={errors.section4?.blockOpenAccountDesc}
                              /> */}
                            </div>
                            {errors.section4?.blockOpenAccountDesc && (
                              <div className="text-danger mb-3">
                                {errors.section4?.blockOpenAccountDesc}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(bankAboutTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setBankAboutTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={bankAboutTitle}
                                onChange={(val) =>
                                  setBankAboutTitle(val)
                                }
                                error={errors.section4?.bankAboutTitle}
                              /> */}
                            </div>
                            {errors.section4?.bankAboutTitle && (
                              <div className="text-danger mb-3">
                                {errors.section4?.bankAboutTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(bankAboutDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setBankAboutDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={bankAboutDesc}
                                onChange={(val) => setBankAboutDesc(val)}
                                error={errors.section4?.bankAboutDesc}
                              /> */}
                            </div>
                            {errors.section4?.bankAboutDesc && (
                              <div className="text-danger mb-3">
                                {errors.section4?.bankAboutDesc}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* 🔹 Multiple Videos Upload */}
                        <div className="row mt-3">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Upload Videos
                            </label>

                            <input
                              type="file"
                              accept="video/*"
                              multiple
                              onChange={videoHandler}
                              className="form-control"
                            />

                            {/* Existing Videos */}
                            {existingVideos.length > 0 && (
                              <div className="mt-3">
                                <h6>Existing Videos</h6>
                                <div className="d-flex flex-wrap gap-3">
                                  {existingVideos.map((url, index) => (
                                    <video
                                      key={index}
                                      src={url}
                                      controls
                                      width="200"
                                      height="120"
                                    />
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* New Uploaded Videos Preview */}
                            {videos.length > 0 && (
                              <div className="mt-3">
                                <h6>New Videos</h6>
                                <div className="d-flex flex-wrap gap-3">
                                  {videos.map((video, index) => (
                                    <div key={index} className="position-relative">
                                      <video
                                        src={URL.createObjectURL(video)}
                                        controls
                                        width="200"
                                        height="120"
                                      />
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-sm position-absolute top-0 end-0"
                                        onClick={() => removeVideo(index)}
                                      >
                                        ✕
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {/* Dynamic Key-Value Pairs */}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Block Open A/C Features
                            </label>
                            {keyValues4.map((pair, index) => (
                              <div
                                key={pair.id || index}
                                className="position-relative border rounded p-3 mb-3"
                              >
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={() => {
                                    const newKV = keyValues4.filter(
                                      (_, i) => i !== index
                                    );
                                    setKeyValues4(newKV);
                                  }}
                                >
                                  ✕
                                </button>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Title
                                  </label>
                                  <textarea
                                    placeholder="Enter Title"
                                    className={`form-control me-2 ${errors.section4?.[`keyValues4_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.key}
                                    onChange={(e) => {
                                      const newKV = [...keyValues4];
                                      newKV[index].key = e.target.value;
                                      setKeyValues4(newKV);
                                    }}
                                  ></textarea>
                                </div>
                                {errors.section4?.[`keyValues4_${index}`] && (
                                  <div className="text-danger mt-1">
                                    {errors.section4[`keyValues4_${index}`]}
                                  </div>
                                )}
                              </div>
                            ))}
                            {errors.section4?.keyValues4 && (
                              <div className="text-danger mb-2">
                                {errors.section4?.keyValues4}
                              </div>
                            )}
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2"
                                onClick={() =>
                                  setKeyValues4([...keyValues4, { key: "", id: new Date().getTime() }])
                                }
                              >
                                + Add Title
                              </button>
                            </div>
                          </div>
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          {/* Back Button */}
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => dispatch({ type: "collpase4" })}
                          >
                            Close
                          </Button>

                          {/* Update Button */}
                          <Button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={handleBlockOpenAccountPageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section6 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section6 && Object.keys(errors.section6).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase6" })}
                  >
                    <div className="cpa">Forex & International Payments Page Content</div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase6 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  <Collapse in={state.collpase6}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image11"]
                                    ? `url(${previews["image11"]})`
                                    : files["image11"]
                                      ? `url(${files["image11"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image11")}
                                id="imageUpload11"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload11"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section6?.image11 && (
                          <div className="text-danger mb-3">
                            {errors.section6?.image11}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(forexTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setForexTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={forexTitle}
                                onChange={(val) => setForexTitle(val)}
                                error={errors.section6?.forexTitle}
                              /> */}
                            </div>
                            {errors.section6?.forexTitle && (
                              <div className="text-danger mb-3">
                                {errors.section6?.forexTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(forexDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setForexDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={forexDesc}
                                onChange={(val) => setForexDesc(val)}
                                error={errors.section6?.forexDesc}
                              /> */}
                            </div>
                            {errors.section6?.forexDesc && (
                              <div className="text-danger mb-3">
                                {errors.section6?.forexDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(forexAboutTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setForexAboutTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={forexAboutTitle}
                                onChange={(val) => setForexAboutTitle(val)}
                                error={errors.section6?.forexAboutTitle}
                              /> */}
                            </div>
                            {errors.section6?.forexAboutTitle && (
                              <div className="text-danger mb-3">
                                {errors.section6?.forexAboutTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(forexAboutDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setForexAboutDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={forexAboutDesc}
                                onChange={(val) => setForexAboutDesc(val)}
                                error={errors.section6?.forexAboutDesc}
                              /> */}
                            </div>
                            {errors.section6?.forexAboutDesc && (
                              <div className="text-danger mb-3">
                                {errors.section6?.forexAboutDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Section Short Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(forexAboutShortDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setForexAboutShortDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={forexAboutDesc}
                                onChange={(val) => setForexAboutDesc(val)}
                                error={errors.section6?.forexAboutDesc}
                              /> */}
                            </div>
                            {errors.section6?.forexAboutShortDesc && (
                              <div className="text-danger mb-3">
                                {errors.section6?.forexAboutShortDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Forex Exchange Features
                            </label>
                            {keyValues5.map((pair, index) => (
                              <div
                                key={pair.id || index}
                                className="position-relative border rounded p-3 mb-3"
                              >
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={() => {
                                    const newKV = keyValues5.filter(
                                      (_, i) => i !== index
                                    );
                                    setKeyValues5(newKV);
                                  }}
                                >
                                  ✕
                                </button>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Title
                                  </label>
                                  <textarea
                                    placeholder="Enter Title"
                                    className={`form-control me-2 ${errors.section6?.[`keyValues5_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.key}
                                    onChange={(e) => {
                                      const newKV = [...keyValues5];
                                      newKV[index].key = e.target.value;
                                      setKeyValues5(newKV);
                                    }}
                                  ></textarea>
                                </div>
                                <div className="mb-3">
                                  <label className="form-label fw-semibold">
                                    Description
                                  </label>
                                  <textarea
                                    placeholder="Enter description"
                                    className={`form-control me-2 ${errors.section6?.[`keyValues5_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.value}
                                    onChange={(e) => {
                                      const newKV = [...keyValues5];
                                      newKV[index].value = e.target.value;
                                      setKeyValues5(newKV);
                                    }}
                                  ></textarea>
                                </div>
                                {errors.section6?.[`keyValues5_${index}`] && (
                                  <div className="text-danger mt-1">
                                    {errors.section6[`keyValues5_${index}`]}
                                  </div>
                                )}
                              </div>
                            ))}
                            {errors.section6?.keyValues5 && (
                              <div className="text-danger mb-2">
                                {errors.section6?.keyValues5}
                              </div>
                            )}
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2"
                                onClick={() =>
                                  setKeyValues5([
                                    ...keyValues5,
                                    { key: "", value: "", id: new Date().getTime() },
                                  ])
                                }
                              >
                                + Add Title-Description
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Title
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(forexYoutubeTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setForexYoutubeTitle(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={forexYoutubeTitle}
                            onChange={(val) => setForexYoutubeTitle(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Description
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(forexYoutubeDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setForexYoutubeDesc(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={forexYoutubeDesc}
                            onChange={(val) => setForexYoutubeDesc(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Link
                          </label>
                          <input
                            type="text"
                            className={`form-control w-full ${errors.section6?.forexYoutubeLink
                              ? "is-invalid"
                              : ""
                              }`}
                            placeholder="Youtube Link"
                            value={forexYoutubeLink} // bind value
                            onChange={(e) =>
                              setForexYoutubeLink(e.target.value)
                            } // update state
                          />
                          {errors.section6?.forexYoutubeLink && (
                            <div className="invalid-feedback mt-1">
                              {errors.section6?.forexYoutubeLink}
                            </div>
                          )}
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase6" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handleForexExchangePageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section5 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section5 && Object.keys(errors.section5).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase5" })}
                  >
                    <div className="cpa">Accommodation in &nbsp; <b>{countryName}</b> &nbsp; Page Content</div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase5 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  <Collapse in={state.collpase5}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview10"
                                style={{
                                  backgroundImage: previews["image10"]
                                    ? `url(${previews["image10"]})`
                                    : files["image10"]
                                      ? `url(${files["image10"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image10")}
                                id="imageUpload10"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload10"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section5?.image10 && (
                          <div className="text-danger mb-3">
                            {errors.section5?.image10}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(accomationTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAccomationTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={accomationTitle}
                                onChange={(val) => setAccomationTitle(val)}
                                error={errors.section5?.accomationTitle}
                              /> */}
                            </div>
                            {errors.section5?.accomationTitle && (
                              <div className="text-danger mb-3">
                                {errors.section5?.accomationTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(accomationDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAccomationDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={accomationDesc}
                                onChange={(val) => setAccomationDesc(val)}
                                error={errors.section5?.accomationDesc}
                              /> */}
                            </div>
                            {errors.section5?.accomationDesc && (
                              <div className="text-danger mb-3">
                                {errors.section5?.accomationDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(accomationAboutDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAccomationAboutDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={accomationAboutDesc}
                                onChange={(val) => setAccomationAboutDesc(val)}
                                error={errors.section7?.accomationAboutDesc}
                              /> */}
                            </div>
                            {errors.section7?.accomationAboutDesc && (
                              <div className="text-danger mb-3">
                                {errors.section7?.accomationAboutDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Title
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(accomationYoutubeTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setAccomationYoutubeTitle(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={accomationYoutubeTitle}
                            onChange={(val) => setAccomationYoutubeTitle(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Description
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(accomationYoutubeDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setAccomationYoutubeDesc(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={accomationYoutubeDesc}
                            onChange={(val) => setAccomationYoutubeDesc(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Link
                          </label>
                          <input
                            type="text"
                            className={`form-control w-full ${errors.section5?.accomationYoutubeLink
                              ? "is-invalid"
                              : ""
                              }`}
                            placeholder="Youtube Link"
                            value={accomationYoutubeLink} // bind value
                            onChange={(e) =>
                              setAccomationYoutubeLink(e.target.value)
                            } // update state
                          />
                          {errors.section5?.accomationYoutubeLink && (
                            <div className="invalid-feedback mt-1">
                              {errors.section5?.accomationYoutubeLink}
                            </div>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Documents & Links
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(accomationDocuments).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setAccomationDocuments(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={accomationDocuments}
                                onChange={(val) => setAccomationDocuments(val)}
                                error={errors.section0?.accomationDocuments}
                              /> */}
                            </div>
                            {errors.section0?.accomationDocuments && (
                              <div className="text-danger mb-3">
                                {errors.section0?.accomationDocuments}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Accommodation Detail Note
                          </label>
                          <input
                            type="text"
                            className={`form-control w-full ${errors.section5?.accomationDetailsDesc
                              ? "is-invalid"
                              : ""
                              }`}
                            placeholder="Accommodation Detail Note"
                            value={accomationDetailsDesc} // bind value
                            onChange={(e) =>
                              setAccomationDetailsDesc(e.target.value)
                            } // update state
                          />
                          {errors.section5?.accomationDetailsDesc && (
                            <div className="invalid-feedback mt-1">
                              {errors.section5?.accomationDetailsDesc}
                            </div>
                          )}
                        </div>
                        <div className="mb-4">
                          <label className="form-label">Accommodation details</label>
                          {accomationDetails.map((item, index) => (
                            <div
                              key={index}
                              className="position-relative border rounded p-3 mb-3"
                            >
                              <button
                                type="button"
                                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
                                onClick={() => {
                                  const newKV = accomationDetails.filter(
                                    (_, i) => i !== index
                                  );
                                  setAccomationDetails(newKV);
                                }}
                              >
                                X
                              </button>
                              <div className="mb-3 mt-1">
                                <label className="form-label fw-semibold">Title</label>
                                <textarea
                                  rows={2}
                                  placeholder="Title"
                                  className="form-control"
                                  value={item.title ?? ""}
                                  onChange={(e) => {
                                    const newKV = [...accomationDetails];
                                    newKV[index].title = e.target.value;
                                    setAccomationDetails(newKV);
                                  }}
                                ></textarea>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-semibold">
                                  Description
                                </label>
                                <textarea
                                  rows={2}
                                  placeholder="Description"
                                  className="form-control"
                                  value={item.desc ?? ""}
                                  onChange={(e) => {
                                    const newKV = [...accomationDetails];
                                    newKV[index].desc = e.target.value;
                                    setAccomationDetails(newKV);
                                  }}
                                ></textarea>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-semibold">
                                  Badges
                                </label>
                                <textarea
                                  rows={2}
                                  placeholder="Badge"
                                  className="form-control"
                                  value={item.badge}
                                  onChange={(e) => {
                                    const newKV = [...accomationDetails];
                                    newKV[index].badge = e.target.value;
                                    setAccomationDetails(newKV);
                                  }}
                                ></textarea>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-semibold">
                                  URL
                                </label>
                                <textarea
                                  rows={2}
                                  placeholder="URL"
                                  className="form-control"
                                  value={item.url}
                                  onChange={(e) => {
                                    const newKV = [...accomationDetails];
                                    newKV[index].url = e.target.value;
                                    setAccomationDetails(newKV);
                                  }}
                                ></textarea>
                              </div>
                              <div className="mb-3">
                                <label className="form-label fw-semibold">
                                  Image
                                </label>

                                <input
                                  type="file"
                                  accept="image/*"
                                  className="form-control"
                                  onChange={(e) => {
                                    const newKV = [...accomationDetails];
                                    newKV[index].image = e.target.files[0];
                                    setAccomationDetails(newKV);
                                  }}
                                />
                              </div>

                              {/* Preview */}
                              {item.image && (
                                <div className="mb-2">
                                  <small className="text-muted">
                                    Preview:
                                  </small>

                                  <div className="mt-1">
                                    <img
                                      src={
                                        item.image instanceof File
                                          ? URL.createObjectURL(item.image)
                                          : item.image // URL from API
                                      }
                                      alt="Feature"
                                      style={{
                                        width: "120px",
                                        height: "80px",
                                        objectFit: "cover",
                                        borderRadius: "6px",
                                        border: "1px solid #ddd",
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                          <div>
                            <button
                              type="button"
                              className="btn btn-primary mt-2 block"
                              onClick={() =>
                                setAccomationDetails([
                                  ...accomationDetails,
                                  { title: "", desc: "", badge: "", url: "", image: "", id: new Date().getTime() },
                                ])
                              }
                            >
                              + Add Detail
                            </button>
                          </div>
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase5" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handleAccommodationPageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section7 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section7 && Object.keys(errors.section7).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase7" })}
                  >
                    <div className="cpa">Visa Application Process Page Content</div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase7 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  <Collapse in={state.collpase7}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview12"
                                style={{
                                  backgroundImage: previews["image12"]
                                    ? `url(${previews["image12"]})`
                                    : files["image12"]
                                      ? `url(${files["image12"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image12")}
                                id="imageUpload12"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload12"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section7?.image12 && (
                          <div className="text-danger mb-3">
                            {errors.section7?.image12}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaAppoinmentTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaAppoinmentTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaAppoinmentTitle}
                                onChange={(val) => setVisaAppoinmentTitle(val)}
                                error={errors.section7?.visaAppoinmentTitle}
                              /> */}
                            </div>
                            {errors.section7?.visaAppoinmentTitle && (
                              <div className="text-danger mb-3">
                                {errors.section7?.visaAppoinmentTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaAppoinmentDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaAppoinmentDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaAppoinmentDesc}
                                onChange={(val) => setVisaAppoinmentDesc(val)}
                                error={errors.section7?.visaAppoinmentDesc}
                              /> */}
                            </div>
                            {errors.section7?.visaAppoinmentDesc && (
                              <div className="text-danger mb-3">
                                {errors.section7?.visaAppoinmentDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaAppointmentSectionTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaAppointmentSectionTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaAppointmentSectionTitle}
                                onChange={(val) => setVisaAppointmentSectionTitle(val)}
                                error={errors.section7?.visaAppointmentSectionTitle}
                              /> */}
                            </div>
                            {errors.section7?.visaAppointmentSectionTitle && (
                              <div className="text-danger mb-3">
                                {errors.section7?.visaAppointmentSectionTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaAppointmentSectionDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaAppointmentSectionDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaAppointmentSectionDesc}
                                onChange={(val) => setVisaAppointmentSectionDesc(val)}
                                error={errors.section7?.visaAppointmentSectionDesc}
                              /> */}
                            </div>
                            {errors.section7?.visaAppointmentSectionDesc && (
                              <div className="text-danger mb-3">
                                {errors.section7?.visaAppointmentSectionDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Visa Document Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaAppointmentDocTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaAppointmentDocTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaAppointmentDocTitle}
                                onChange={(val) => setVisaAppointmentDocTitle(val)}
                                error={errors.section7?.visaAppointmentDocTitle}
                              /> */}
                            </div>
                            {errors.section7?.visaAppointmentDocTitle && (
                              <div className="text-danger mb-3">
                                {errors.section7?.visaAppointmentDocTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Visa Document Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CkEditorBlog
                                value={visaAppointmentDocDesc}
                                onChange={(val) => setVisaAppointmentDocDesc(val)}
                                error={errors.section7?.visaAppointmentDocDesc}
                              />
                            </div>
                            {errors.section7?.visaAppointmentDocDesc && (
                              <div className="text-danger mb-3">
                                {errors.section7?.visaAppointmentDocDesc}
                              </div>
                            )}
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Documents Requirements
                            </label>
                            {keyValues8.map((pair, index) => (
                              <div
                                key={pair.id || index}
                                className="position-relative border rounded p-3 mb-3"
                              >
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={() => {
                                    const newKV = keyValues8.filter(
                                      (_, i) => i !== index
                                    );
                                    setKeyValues8(newKV);
                                  }}
                                >
                                  ✕
                                </button>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Title
                                  </label>
                                  <textarea
                                    placeholder="Enter Title"
                                    className={`form-control me-2 ${errors.section1?.[`keyValues8_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.key}
                                    onChange={(e) => {
                                      const newKV = [...keyValues8];
                                      newKV[index].key = e.target.value;
                                      setKeyValues8(newKV);
                                    }}
                                  ></textarea>
                                </div>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Description
                                  </label>
                                  <CKEditor
                                    editor={CustomClassicEditor}
                                    data={(pair.value).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                    onChange={(event, editor) => {
                                      const newKV = [...keyValues8];
                                      newKV[index].value = editor.getData();
                                      setKeyValues8(newKV);
                                    }}
                                  />
                                  {/* <CkEditorBlog
                                    value={pair.value}
                                    onChange={(val) => {
                                      const newKV = [...keyValues8];
                                      newKV[index].value = val;
                                      setKeyValues8(newKV);
                                    }}
                                  /> */}
                                </div>
                                {errors.section1?.[`keyValues8_${index}`] && (
                                  <div className="text-danger mt-1">
                                    {errors.section1[`keyValues8_${index}`]}
                                  </div>
                                )}
                              </div>
                            ))}
                            {errors.section1?.keyValues8 && (
                              <div className="text-danger mb-2">
                                {errors.section1?.keyValues8}
                              </div>
                            )}
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2"
                                onClick={() =>
                                  setKeyValues8([...keyValues8, { key: "", value: "", id: new Date().getTime() }])
                                }
                              >
                                + Add Title
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-4">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Application Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaAppointmentApplicationTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaAppointmentApplicationTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaAppointmentApplicationTitle}
                                onChange={(val) => setVisaAppointmentApplicationTitle(val)}
                                error={errors.section7?.visaAppointmentApplicationTitle}
                              /> */}
                            </div>
                            {errors.section7?.visaAppointmentApplicationTitle && (
                              <div className="text-danger mb-3">
                                {errors.section7?.visaAppointmentApplicationTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Application Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaAppointmentApplicationDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaAppointmentApplicationDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaAppointmentApplicationDesc}
                                onChange={(val) => setVisaAppointmentApplicationDesc(val)}
                                error={errors.section7?.visaAppointmentApplicationDesc}
                              /> */}
                            </div>
                            {errors.section7?.visaAppointmentApplicationDesc && (
                              <div className="text-danger mb-3">
                                {errors.section7?.visaAppointmentApplicationDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Title
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(visaAppoinmentYoutubeTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setVisaAppoinmentYoutubeTitle(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={visaAppoinmentYoutubeTitle}
                            onChange={(val) => setVisaAppoinmentYoutubeTitle(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Description
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(visaAppoinmentYoutubeDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setVisaAppoinmentYoutubeDesc(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={visaAppoinmentYoutubeDesc}
                            onChange={(val) => setVisaAppoinmentYoutubeDesc(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Link
                          </label>
                          <input
                            type="text"
                            className={`form-control w-full ${errors.section7?.visaAppoinmentYoutubeLink
                              ? "is-invalid"
                              : ""
                              }`}
                            placeholder="Youtube Link"
                            value={visaAppoinmentYoutubeLink} // bind value
                            onChange={(e) =>
                              setVisaAppoinmentYoutubeLink(e.target.value)
                            } // update state
                          />
                          {errors.section7?.visaAppoinmentYoutubeLink && (
                            <div className="invalid-feedback mt-1">
                              {errors.section7?.visaAppoinmentYoutubeLink}
                            </div>
                          )}
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase7" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handleVisaAppointmentPageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section8 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section8 && Object.keys(errors.section8).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase8" })}
                  >
                    <div className="cpa">Biomatrics Appointment Page Content</div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase8 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  <Collapse in={state.collpase8}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview13"
                                style={{
                                  backgroundImage: previews["image13"]
                                    ? `url(${previews["image13"]})`
                                    : files["image13"]
                                      ? `url(${files["image13"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image13")}
                                id="imageUpload13"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload13"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section8?.image13 && (
                          <div className="text-danger mb-3">
                            {errors.section8?.image13}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaDocumentTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaDocumentTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaDocumentTitle}
                                onChange={(val) => setVisaDocumentTitle(val)}
                                error={errors.section8?.visaDocumentTitle}
                              /> */}
                            </div>
                            {errors.section8?.visaDocumentTitle && (
                              <div className="text-danger mb-3">
                                {errors.section8?.visaDocumentTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaDocumentDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaDocumentDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaDocumentDesc}
                                onChange={(val) => setVisaDocumentDesc(val)}
                                error={errors.section8?.visaDocumentDesc}
                              /> */}
                            </div>
                            {errors.section8?.visaDocumentDesc && (
                              <div className="text-danger mb-3">
                                {errors.section8?.visaDocumentDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <label className="form-label fw-semibold">
                          Document Required Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview16"
                                style={{
                                  backgroundImage: previews["image16"]
                                    ? `url(${previews["image16"]})`
                                    : files["image16"]
                                      ? `url(${files["image16"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image16")}
                                id="imageUpload16"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload16"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section8?.image16 && (
                          <div className="text-danger mb-3">
                            {errors.section8?.image16}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Document Required Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaDocumentSectionTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaDocumentSectionTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaDocumentSectionTitle}
                                onChange={(val) => setVisaDocumentSectionTitle(val)}
                                error={errors.section8?.visaDocumentSectionTitle}
                              /> */}
                            </div>
                            {errors.section8?.visaDocumentSectionTitle && (
                              <div className="text-danger mb-3">
                                {errors.section8?.visaDocumentSectionTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Visa Document Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CkEditorBlog
                                value={visaDocumentSectionDesc}
                                onChange={(val) => setVisaDocumentSectionDesc(val)}
                                error={errors.section8?.visaDocumentSectionDesc}
                              />
                            </div>
                            {errors.section8?.visaDocumentSectionDesc && (
                              <div className="text-danger mb-3">
                                {errors.section8?.visaDocumentSectionDesc}
                              </div>
                            )}
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Visa Document Requirements
                            </label>
                            {keyValues7.map((pair, index) => (
                              <div
                                key={pair.id || index}
                                className="position-relative border rounded p-3 mb-3"
                              >
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={() => {
                                    const newKV = keyValues7.filter(
                                      (_, i) => i !== index
                                    );
                                    setKeyValues7(newKV);
                                  }}
                                >
                                  ✕
                                </button>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Title
                                  </label>
                                  <textarea
                                    placeholder="Enter Title"
                                    className={`form-control me-2 ${errors.section1?.[`keyValues7_${index}`]
                                      ? "is-invalid"
                                      : ""
                                      }`}
                                    rows={2}
                                    value={pair.key}
                                    onChange={(e) => {
                                      const newKV = [...keyValues7];
                                      newKV[index].key = e.target.value;
                                      setKeyValues7(newKV);
                                    }}
                                  ></textarea>
                                </div>
                                <div className="mb-3 mt-1">
                                  <label className="form-label fw-semibold">
                                    Description
                                  </label>
                                  <CKEditor
                                    editor={CustomClassicEditor}
                                    data={(pair.value).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                    onChange={(event, editor) => {
                                      const newKV = [...keyValues7];
                                      newKV[index].value = editor.getData();
                                      setKeyValues7(newKV);
                                    }}
                                  />
                                  {/* <CkEditorBlog
                                    value={pair.value}
                                    onChange={(val) => {
                                      const newKV = [...keyValues7];
                                      newKV[index].value = val;
                                      setKeyValues7(newKV);
                                    }}
                                  /> */}
                                </div>
                                {errors.section1?.[`keyValues7_${index}`] && (
                                  <div className="text-danger mt-1">
                                    {errors.section1[`keyValues7_${index}`]}
                                  </div>
                                )}
                              </div>
                            ))}
                            {errors.section1?.keyValues7 && (
                              <div className="text-danger mb-2">
                                {errors.section1?.keyValues7}
                              </div>
                            )}
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary mt-2"
                                onClick={() =>
                                  setKeyValues7([...keyValues7, { key: "", value: "", id: new Date().getTime() }])
                                }
                              >
                                + Add Title
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Do Don't Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaDocumentDoDontTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaDocumentDoDontTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaDocumentDoDontTitle}
                                onChange={(val) => setVisaDocumentDoDontTitle(val)}
                                error={errors.section8?.visaDocumentDoDontTitle}
                              /> */}
                            </div>
                            {errors.section8?.visaDocumentDoDontTitle && (
                              <div className="text-danger mb-3">
                                {errors.section8?.visaDocumentDoDontTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Do Don't Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaDocumentDoDontDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaDocumentDoDontDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaDocumentDoDontDesc}
                                onChange={(val) => setVisaDocumentDoDontDesc(val)}
                                error={errors.section8?.visaDocumentDoDontDesc}
                              /> */}
                            </div>
                            {errors.section8?.visaDocumentDoDontDesc && (
                              <div className="text-danger mb-3">
                                {errors.section8?.visaDocumentDoDontDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              After Biomatrics Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaDocumentAfterTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaDocumentAfterTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaDocumentAfterTitle}
                                onChange={(val) => setVisaDocumentAfterTitle(val)}
                                error={errors.section8?.visaDocumentAfterTitle}
                              /> */}
                            </div>
                            {errors.section8?.visaDocumentAfterTitle && (
                              <div className="text-danger mb-3">
                                {errors.section8?.visaDocumentAfterTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              After Biomatrics Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(visaDocumentAfterDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setVisaDocumentAfterDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={visaDocumentAfterDesc}
                                onChange={(val) => setVisaDocumentAfterDesc(val)}
                                error={errors.section8?.visaDocumentAfterDesc}
                              /> */}
                            </div>
                            {errors.section8?.visaDocumentAfterDesc && (
                              <div className="text-danger mb-3">
                                {errors.section8?.visaDocumentAfterDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Title
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(visaDocumentYoutubeTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setVisaDocumentYoutubeTitle(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={visaDocumentYoutubeTitle}
                            onChange={(val) => setVisaDocumentYoutubeTitle(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Description
                          </label>
                          <CKEditor
                            editor={CustomClassicEditor}
                            data={(partTimeTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                            onChange={(event, editor) => {
                              setPartTimeTitle(editor.getData());
                            }}
                          />
                          {/* <CkEditorBlog
                            value={visaDocumentYoutubeDesc}
                            onChange={(val) => setVisaDocumentYoutubeDesc(val)}
                          /> */}
                        </div>
                        <div className="mb-3 mt-3">
                          <label className="form-label fw-semibold">
                            Youtube Link
                          </label>
                          <input
                            type="text"
                            className={`form-control w-full ${errors.section8?.visaDocumentYoutubeLink
                              ? "is-invalid"
                              : ""
                              }`}
                            placeholder="Youtube Link"
                            value={visaDocumentYoutubeLink} // bind value
                            onChange={(e) =>
                              setVisaDocumentYoutubeLink(e.target.value)
                            } // update state
                          />
                          {errors.section8?.visaDocumentYoutubeLink && (
                            <div className="invalid-feedback mt-1">
                              {errors.section8?.visaDocumentYoutubeLink}
                            </div>
                          )}
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase8" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handleVisaDocumentPageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
              {coutryAdd && !state.section2 && (
                <div className="filter cm-content-box box-primary">
                  <div
                    className={`content-title ${errors.section2 && Object.keys(errors.section2).length > 0
                      ? "bg-danger"
                      : ""
                      }`}
                    onClick={() => dispatch({ type: "collpase2" })}
                  >
                    <div className="cpa">Part-Time Jobs &nbsp; <b>{countryName}</b> &nbsp; Page Content</div>
                    <div className="tools d-flex align-items-center gap-2">
                      {/* ✅ Show edit only when expanded */}
                      {!state.collpase2 ? (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-edit text-black"></i>
                        </Link>
                      ) : (
                        <Link to={"#"} className="text-primary">
                          <i className="fas fa-angle-up text-black"></i>
                        </Link>
                      )}
                    </div>
                  </div>
                  <Collapse in={state.collpase2}>
                    <div className="cm-content-body form excerpt">
                      <div className="card-body">
                        <label className="form-label fw-semibold">
                          Hero Section Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image6"]
                                    ? `url(${previews["image6"]})`
                                    : files["image6"]
                                      ? `url(${files["image6"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image6")}
                                id="imageUpload5"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload5"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section2?.image6 && (
                          <div className="text-danger mb-3">
                            {errors.section2?.image6}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Title
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(partTimeTitle).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setPartTimeTitle(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={partTimeTitle}
                                onChange={(val) => setPartTimeTitle(val)}
                                error={errors.section2?.partTimeTitle}
                              /> */}
                            </div>
                            {errors.section2?.partTimeTitle && (
                              <div className="text-danger mb-3">
                                {errors.section2?.partTimeTitle}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              Hero Section Description
                            </label>
                            <div className="custom-ekeditor cms-radius add-content-ckeditor mb-3">
                              <CKEditor
                                editor={CustomClassicEditor}
                                data={(partTimeDesc).replace(/\[empty_line\]/g, '<div data-empty-line="true"></div>') || ""}
                                onChange={(event, editor) => {
                                  setPartTimeDesc(editor.getData());
                                }}
                              />
                              {/* <CkEditorBlog
                                value={partTimeDesc}
                                onChange={(val) => setPartTimeDesc(val)}
                                error={errors.section2?.partTimeDesc}
                              /> */}
                            </div>
                            {errors.section2?.partTimeDesc && (
                              <div className="text-danger mb-3">
                                {errors.section2?.partTimeDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <label className="form-label fw-semibold">
                          About Part Time Job In {countryName} Image
                        </label>
                        <div className="avatar-upload d-flex align-items-center mb-3">
                          <div className=" position-relative ">
                            <div className="avatar-preview">
                              <div
                                id="imagePreview"
                                style={{
                                  backgroundImage: previews["image7"]
                                    ? `url(${previews["image7"]})`
                                    : files["image7"]
                                      ? `url(${files["image7"]})`
                                      : `url(${NoImage})`,
                                }}
                              ></div>
                            </div>
                            <div className="change-btn d-flex align-items-center flex-wrap">
                              <input
                                type="file"
                                onChange={(e) => fileHandler(e, "image7")}
                                id="imageUpload6"
                                className="d-none"
                              />
                              <label
                                htmlFor="imageUpload6"
                                className="btn btn-primary ms-0"
                              >
                                Select Image
                              </label>
                            </div>
                          </div>
                        </div>
                        {errors.section2?.image7 && (
                          <div className="text-danger mb-3">
                            {errors.section2?.image7}
                          </div>
                        )}
                        <div className="row">
                          <div className="col-xl-12 col-sm-12">
                            <label className="form-label fw-semibold">
                              About Part Time Job In {countryName} Description
                            </label>
                            <textarea
                              className="form-control"
                              placeholder="Enter description"
                              rows="2"
                              value={partTimeShortDesc}
                              onChange={(e) =>
                                setPartTimeShortDesc(e.target.value)
                              }
                            ></textarea>
                            {errors.section2?.partTimeShortDesc && (
                              <div className="text-danger mb-3 mt-1">
                                {errors.section2?.partTimeShortDesc}
                              </div>
                            )}
                          </div>
                        </div>
                        <hr style={{ margin: "0px" }} className="mx-2 mt-2" />
                        <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                          <Button
                            type="button"
                            variant="secondary"
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => {
                              dispatch({ type: "collpase2" }); // Close the collapse
                            }}
                          >
                            Close
                          </Button>
                          <Button
                            to={"#"}
                            className="btn btn-primary btn-sm"
                            onClick={handlePartTimePageSave}
                          >
                            Update
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCountry;
